<template>
  <div
    :class="['lcu-shimmer-circle', 'lcu-shimmer-' + size]"
    :style="{ width: size, height: size }"/>
</template>

<script>
export default {
  name: 'shimmer-circle',
  props: {
    size: {
      type: String,
      required: false,
      default: 'default',
    },
  },
};
</script>

<style scoped lang="scss">
.lcu-shimmer-circle {
  animation : shimmer 1.5s infinite linear;
  background: linear-gradient(to right, #bebebe 5%, #e9e9e9 25%, #c2c2c2 36%);
  background-size: 1000px 100%;
  border-radius: 50%;
  opacity: .5;
}

.lcu-shimmer-default {
  height: 35px;
  width: 35px;
}

@keyframes shimmer {
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
}
</style>
